<!--
 * @Description: 级联回显
 * @Author: cxh
 * @Date: 2022-05-24 16:25:08
 * @LastEditTime: 2023-04-18 19:27:14
 * @LastEditors: mdb
-->
<template>
  <span :title="nameFormat">{{ nameFormat || '--' }}</span>
</template>
<script lang="ts" setup>
import { ref, watch, computed } from 'vue'
import { getTreeNameList } from '@/utils/index'
import { useInteractionStore } from '@/stores/interaction'
import useParamCode from '@/hooks/useParamCode'
import type { ParamCodeItem } from '@/typings/common'
const interactionStore = useInteractionStore()
const { getParamCodes } = useParamCode()

const props = defineProps<{
  appId: 'cos_fbu' | 'cos_ofbu' | 'cos_lbu' | 'cos_zbu'
  paramCode?: string
  options?: ParamCodeItem[]
  value: number
  desc?: string // 描述
}>()

const langEnum = {
  'en-US': 'enName',
  'zh-CN': 'cnName'
}

const nameFormat = ref()
const language = computed(() => interactionStore.language)
const formatName = (paramCodeData: { [key: string]: ParamCodeItem[] }, key: string) => {
  const paramCodeDataObj = { ...paramCodeData }
  const config = { label: langEnum[language.value] || 'name' }
  const channelNameList = getTreeNameList(paramCodeDataObj[key], props.value, config).filter((name) => name)
  if (props.desc) channelNameList.push(props.desc)
  nameFormat.value = channelNameList.join('/')
}
const channelName = async () => {
  if (props.paramCode == null) return
  try {
    const paramCodeData = await getParamCodes(props.appId, props.paramCode)
    formatName(paramCodeData, props.paramCode)
  } catch (error) {
    console.error(error)
  }
}

watch(
  (): [number, ParamCodeItem[] | undefined] => [props.value, props.options],
  ([val, options]) => {
    if (val == null) return
    if (typeof options !== 'undefined') {
      const paramCodeData = { paramKey: options }
      formatName(paramCodeData, 'paramKey')
    } else {
      channelName()
    }
  },
  { immediate: true }
)

watch(
  () => language.value,
  () => {
    if (typeof props.options !== 'undefined') {
      const paramCodeData = { paramKey: props.options }
      formatName(paramCodeData, 'paramKey')
    } else {
      channelName()
    }
  }
)
</script>
<script lang="ts">
export default { name: 'CosCascaderText' }
</script>
